import React from 'react';
import { isArray } from 'lodash';
import { useFormikContext } from 'formik';
import ucFirst from '@utils/ucFirst';
import { ReactComponent as IconCross } from '@assets/icons/cross.svg?comp';
import FacetsClearButton from '@atoms/FacetClearButton/FacetsClearButton';
import { nonFacetSearchParams } from '@templates/SearchForm/nonFacetSearchParams';
import { useSearchParams } from 'react-router-dom';
import { useSearchQuestion } from '@context/DataContext';

const FacetPills = () => {
  const { clearFilters } = useSearchQuestion();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setFieldValue, values } = useFormikContext();

  const composeClearedFormikValues = (formValues) => {
    // Preserve query value
    const { query } = formValues;

    const nonFacetFields = nonFacetSearchParams.map((a) => a.paramKey);
    const keys = Object.keys(values).filter((fieldName) => !nonFacetFields.includes(fieldName));

    // Clear facet values
    const clearedFacets = {};
    Object.entries(formValues).forEach(([fieldKey, fieldValue]) => {
      if (keys.indexOf(fieldKey) > -1) {
        if (fieldKey != 'query') {
          if (isArray(fieldValue)) {
            clearedFacets[fieldKey] = [];
          } else {
            clearedFacets[fieldKey] = '';
          }
        }
      } else {
        // keep persistent values
        clearedFacets[fieldKey] = formValues[fieldKey];
      }
    });

    const clearedValues = {
      query,
      ...clearedFacets,
    };

    return clearedValues;
  };

  const getSelectedFilters = () => {
    const nonFacetFields = nonFacetSearchParams.map((a) => a.paramKey);
    // const nonFacetFields = ["collection", "query","ge_openTimestamp"]
    const keys = Object.keys(values).filter((fieldName) => !nonFacetFields.includes(fieldName));

    const getTitle = (t) => {
      if (t.includes('::')) t = t.split('::')[1].trim();
      return t;
    };

    let selected = [];
    if (keys.length) {
      keys.forEach((k) => {
        if (isArray(values[k]))
          values[k].forEach((o) => {
            if (o)
              selected.push({
                name: k,
                selectedValue: o,
                title: getTitle(o),
                isMulti: true,
              });
          });
        else if (values[k])
          selected.push({
            name: k,
            selectedValue: values[k],
            title: getTitle(values[k]),
            isMulti: false,
          });
      });
    }
    return selected;
  };

  const clearSingleFacet = ({ isMulti, name, selectedValue }) => {
    if (isMulti) {
      const selectedIndex = values[name].findIndex((option) => option === selectedValue);
      if (selectedIndex > -1) {
        values[name].splice(selectedIndex, 1);
        setFieldValue(name, values[name]);
      }
    } else {
      setFieldValue(name, '');
    }

    // check if all filters are clearerd then sync
    const selectedFacets = getSelectedFilters();
    if (!selectedFacets.length) handleClearAll();
  };

  const FacetPillButtons = ({ selectedFacets = [] }) => {
    if (selectedFacets.length)
      return (
        <>
          {selectedFacets.map((obj, i) => (
            <button className="base-search-banner__facet-pills--pill" type="button" key={i} onClick={() => clearSingleFacet(obj)}>
              {obj.title}
              <IconCross className="ml-1" />
            </button>
          ))}
        </>
      );
  };

  const handleClearAll = () => {
    const clearedValues = composeClearedFormikValues(values);

    // Set form state
    Object.entries(clearedValues).forEach(([fieldKey, fieldValue]) => {
      setFieldValue(fieldKey, fieldValue);
    });

    // Set URL search params
    const clearedUrlSearchParams = new URLSearchParams();
    // Preserve non-facet URL search params
    nonFacetSearchParams.forEach((paramConfig) => {
      const { paramKey } = paramConfig;
      if (paramKey !== 'query') {
        const currentSearchParamValue = searchParams.get(paramKey)?.trim();
        if (currentSearchParamValue) {
          clearedUrlSearchParams.set(paramKey, currentSearchParamValue);
        }
      }
    });
    setSearchParams(clearedUrlSearchParams);

    // Request new data from Funnelback
    clearFilters(clearedUrlSearchParams);
  };

  const selectedFacets = getSelectedFilters();
  if (selectedFacets.length)
    return (
      <div className="base-search-banner__facet-pills">
        <div className="base-search-banner__facet-pills-selected">
          <strong>Refine By:</strong>
          <FacetPillButtons selectedFacets={selectedFacets} />
          <FacetsClearButton handleClearAll={handleClearAll} />
        </div>
      </div>
    );
  else return <></>;
};

export default FacetPills;
